<mat-form-field appearance="fill" class="container">
    <mat-label>{{ title }}</mat-label>
    <mat-chip-list #chipList class="chips" [disabled]="availableColumns.length == 0">

        <mat-chip *ngFor="let col of selected" (removed)="handleRemoveGroupingColumn(col)" [removable]="!disabled" class="selected-chip">
            <span>{{ getColumnName(col) | translate }}</span>
            <mat-icon class="no-copy" style="color: red;" matChipRemove svgIcon="close"></mat-icon>
        </mat-chip>

        <mat-chip class="add-icon-chip">
            <mat-icon *ngIf="canDisplayAddCircle() && !disabled" class="no-copy" svgIcon="add_circle_fill"></mat-icon>

            <mat-select #selectTrigger (selectionChange)="handleSelectedGroupingColumn($event.value, selectTrigger)"
                style="opacity: 0; width: 0; height: 0; position: absolute;">
                <ng-container *ngFor="let col of availableColumns">
                    <mat-option [value]="col.name" *ngIf="isColumnAvailableToSelect(col.name)">
                        {{ col.toTranslate | translate}}
                    </mat-option>
                </ng-container>
            </mat-select>
        </mat-chip>

    </mat-chip-list>
</mat-form-field>